var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocialYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 14,
    width: 20,
    viewBox: "0 0 20 14",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#263A80",
    d: "M19.52,2.19c-0.23-0.86-0.9-1.54-1.76-1.77C16.21,0,10,0,10,0S3.79,0,2.24,0.42 C1.38,0.65,0.71,1.33,0.48,2.19C0.06,3.75,0.06,7,0.06,7s0,3.25,0.42,4.81c0.23,0.86,0.9,1.54,1.76,1.77C3.79,14,10,14,10,14 s6.21,0,7.76-0.42c0.85-0.23,1.53-0.91,1.76-1.77C19.94,10.25,19.94,7,19.94,7S19.94,3.75,19.52,2.19z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "7.97,9.95 7.97,4.05 13.16,7  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialYoutube);
export default __webpack_public_path__ + "static/media/social-youtube.693f8c19b9c1d83547b8c97a441754fb.svg";
export { ForwardRef as ReactComponent };